import '../Scss/_default/style.scss';
import './default/accordion';
import './default/footer';
import './default/header';
import './default/modal';
import './default/personal-content-wizard';
import './default/sidebar-wizard';
import './default/slider';
import * as components from './frontend/components';
import { initialize as initializeRecentSystemsTracker } from './frontend/components/RecentSystemsTracker';

const run = () => {
    const componentNames = Object.keys(components);
    for (let i = 0; i < componentNames.length; i++) {
        const componentName = componentNames[i];

        // Find all instances of the component
        const elements = document.querySelectorAll(
            `[data-component="${componentName}"]`
        );
        for (let j = 0; j < elements.length; j++) {
            const element = elements[j];
            try {
                // Initialise component on element
                new components[componentName](element);
            } catch (error) {
                console.warn(`Failed to initialize ${componentName}:`, error);
            }
        }
    }
};

// Initialize global recent systems tracker after components
// This runs once and tracks system clicks across the entire site
const initializeTracker = () => {
    try {
        initializeRecentSystemsTracker();
    } catch (error) {
        console.warn('RecentSystemsTracker initialization failed:', error);
    }
};

setTimeout(() => {
    run();
    initializeTracker();
}, 0);
document.addEventListener('Neos.PageLoaded', () => {
    run();
    initializeTracker();
});
